import ReactDOM from 'react-dom';

// Css
import './style/index.css';

// Components
import App from './components/App';

ReactDOM.render(
    <App />,
    document.getElementById('root')
);